'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Divider-module_hr__Ej0Np{border:none;border-bottom:1px solid #e0e0e0}";
var styles = {"hr":"Divider-module_hr__Ej0Np"};
styleInject["default"](css_248z, 'fc93b836-43aa-40af-8f5b-804206b61e93');

exports["default"] = styles;
